import React from 'react';
import { Outlet, NavLink, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../contexts/LanguageContext';

/**
 * AdminPage — Tab-Container fuer Block-3-Admin-Subseiten.
 * Routes:
 *   /admin               -> redirect zu /admin/tenants (via index-Route in App.js)
 *   /admin/tenants       -> TenantManagementPage
 *   /admin/admins        -> ProviderAdminsPage
 *   /admin/permissions   -> BerechtigungenPage
 *
 * Guard: nur fuer isAdmin (platform_admin | org_admin).
 */
export default function AdminPage() {
  const { t } = useTranslation();
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  const tabs = [
    { key: 'tenants',         to: '/admin/tenants',         label: t('nav.admin.tenants') },
    { key: 'licenses',        to: '/admin/licenses',        label: t('nav.admin.licenses') },
    { key: 'admins',          to: '/admin/admins',          label: t('nav.admin.admins') },
    { key: 'permissions',     to: '/admin/permissions',     label: t('nav.admin.permissions') },
    { key: 'tool-connections', to: '/admin/tool-connections', label: 'Tool-Verbindungen' },
    { key: 'tool-urls',        to: '/admin/tool-urls',        label: t('nav.admin.toolUrls') },
    { key: 'instances',       to: '/admin/instances',       label: t('nav.admin.instances', 'Instanzen') },
    { key: 'demo-tenants',    to: '/admin/demo-tenants',    label: t('nav.admin.demoTenants', 'DEMO-Mandanten') },
  ];

  return (
    <>
      <div className="page-header">
        <div className="page-title">{t('admin.title')}</div>
        <div className="page-subtitle">{t('admin.subtitle')}</div>

        {/* Tab-Leiste */}
        <div
          role="tablist"
          style={{
            display: 'flex', gap: 4, marginTop: 16, marginBottom: -1,
            borderBottom: '1px solid var(--border)',
          }}
        >
          {tabs.map(tab => (
            <NavLink
              key={tab.key}
              to={tab.to}
              role="tab"
              style={({ isActive }) => ({
                padding: '10px 18px',
                fontSize: 13,
                fontWeight: 600,
                color: isActive ? 'var(--accent-hover)' : 'var(--text-muted)',
                background: isActive ? 'var(--bg-card)' : 'transparent',
                border: '1px solid transparent',
                borderBottom: isActive ? '2px solid var(--accent)' : '2px solid transparent',
                borderRadius: '8px 8px 0 0',
                textDecoration: 'none',
                transition: 'color .15s, background .15s',
                marginBottom: -1,
              })}
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>

      <div className="page-content">
        <Outlet />
      </div>
    </>
  );
}
